import { Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DxTreeViewComponent } from 'devextreme-angular';
import { Item } from 'devextreme/ui/context_menu';
import { OptionChangedEvent } from 'devextreme/ui/drawer';
import { Subscription } from 'rxjs';
import { DataService } from './services/data.service';
import { ScreenService } from './services/screen.service';

export enum NavigationSvg {
  Logout = '<svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs><style>.cls-1{fill:#0a4b64;}</style></defs><path class="cls-1" d="M31.5,1.75h-12c-3.72,0-6.75,3.03-6.75,6.75v3.5c0,.41,.34,.75,.75,.75s.75-.34,.75-.75v-3.5c0-2.9,2.35-5.25,5.25-5.25h12c2.89,0,5.25,2.35,5.25,5.25V31.5c0,2.89-2.36,5.25-5.25,5.25h-12c-2.9,0-5.25-2.36-5.25-5.25v-3.5c0-.41-.34-.75-.75-.75s-.75,.34-.75,.75v3.5c0,3.72,3.03,6.75,6.75,6.75h12c3.72,0,6.75-3.03,6.75-6.75V8.5c0-3.72-3.03-6.75-6.75-6.75Z"/><path class="cls-1" d="M3.9,20.75H25.5c.41,0,.75-.34,.75-.75s-.34-.75-.75-.75H3.9l4.7-4.7c.29-.29,.29-.77,0-1.06s-.77-.29-1.06,0l-5.27,5.27c-.68,.68-.68,1.79,0,2.47l5.27,5.27c.15,.15,.34,.22,.53,.22s.38-.07,.53-.22c.29-.29,.29-.77,0-1.06l-4.7-4.7Z"/></svg>',
  ArrowDown = '<svg id="cls-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15"><defs><style>.cls-2{fill:#799ea9;}</style></defs><path class="cls-2" d="M7.5,11.4c-.38,0-.77-.15-1.06-.44L.79,5.31c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l5.29,5.29L12.79,3.9c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-5.65,5.65c-.29,.29-.68,.44-1.06,.44Z"/></svg>',
}

@Component({
  selector: 'custom-arena',
  templateUrl: './custom-arena.component.html',
  styleUrls: ['./custom-arena.component.scss'],
  styles: [],
})
export class CustomArenaComponent implements OnInit, OnChanges {
  @ViewChild('treeview') menu: DxTreeViewComponent;
  @Input() locationMenu: boolean = false;
  @Input() navigationItems: any;
  @Input() logoIcon: string;
  @Input() firstLogo: string;
  @Input() secondLogo: string;
  @Input() visiblityLogo: boolean = false;
  @Input() showLogout = true;
  @Input() logoutText = 'Ausloggen';
  @Input() logoutIcon = 'assets/images/logout.svg';
  @Input() logoMiniatureIcon: string;
  @Input() logoNavigationBorder: string;
  @Input() showNavigationBorder = true;
  @Input() toolBarFirstTitle: string;
  @Input() toolBarSecondTitle: string;
  @Input() updateToolBarTitles = true;
  @Input() navigationBorderFirstTitle: string;
  @Input() navigationBorderSecondTitle: string;
  @Input() userMessage = true;
  @Input() userNotification = true;
  @Input() userFunction: string;
  @Input() currentUserName: string;
  @Input() loginLogo: string;
  @Input() showBackButton = false;
  @Input() showMenuToggleButton = false;
  @Input() userAvatar: string;
  @Input() showToggleButton = false;
  @Input() visiblityDrawer = true;
  @Input() contextMenuAdditionalItems: Item[] = [];
  @Output() onNavigationItemClick: EventEmitter<any> = new EventEmitter();
  @Output() getLoginInfo: EventEmitter<any> = new EventEmitter();
  @Output() avatarClick = new EventEmitter<void>();
  @Output() menuToggle: EventEmitter<boolean> = new EventEmitter();
  @Output() onCloseOnOutsideClick: EventEmitter<boolean> = new EventEmitter();
  public flexValue = '0';
  public shaderEnabled = false;
  public menuOpened: boolean;
  public layoutTitle: string;
  public menuMode = 'shrink';
  public menuRevealMode = 'expand';
  public minMenuSize = 0;
  public selectedRoute: string;
  public toastTemplate = 'success';
  public toastMessage: string;
  public displayGoBackButton: boolean;
  public contextMenuItems = [
    {
      text: 'Logout',
      icon: NavigationSvg.Logout,
      onClick: () => {
        this.logout();
      },
    },
  ];

  private _temporaryMenuOpened = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private screen: ScreenService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private location: Location,
    private router: Router,
    private dataService: DataService
  ) {
    iconRegistry.addSvgIconLiteral('logout', sanitizer.bypassSecurityTrustHtml(NavigationSvg.Logout));
    iconRegistry.addSvgIconLiteral('arrowDown', sanitizer.bypassSecurityTrustHtml(NavigationSvg.ArrowDown));
  }

  async ngOnInit(): Promise<void> {
    if (this.showLogout) {
      this.flexValue = '10';
    } else {
      this.flexValue = '0';
    }
    this.menuOpened = true;
    this.updateDrawer();
    if (!this.currentUserName) {
      const userInformations = await this.dataService.getUserInformations();
      if (userInformations.person) {
        this.userAvatar = userInformations?.person.ImgPortrait as string;
        this.currentUserName = userInformations?.person.FirstName + ' ' + userInformations?.person.LastName;
        this.getLoginInfo.emit(userInformations);
      } else {
        this.currentUserName = userInformations?.loginInfo.displayName as string;
      }
    }
    this.cdr.markForCheck();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['contextMenuAdditionalItems']?.currentValue?.length > 0) {
      this.contextMenuItems = [...changes['contextMenuAdditionalItems'].currentValue];
    }
  }

  public onDrawerOptionChanged(event: OptionChangedEvent): void {
    if (event.name === 'opened') if (event.value === false) this.onCloseOnOutsideClick.emit(true);
  }

  public toggleMenu(e: any): void {
    this.menuOpened = !this.menuOpened;
    this.menuToggle.emit(this.menuOpened);

    e.stopPropagation();
  }

  public logout(): void {
    this.router.navigateByUrl('/login');
    localStorage.clear();
    sessionStorage.clear();
  }

  public onMenuItemClick(event: any): void {
    if (!event.itemData.items) {
      if (this.updateToolBarTitles) {
        this.toolBarSecondTitle = event.itemData.toolbarTitle || event.itemData.text;
      }
      if (this.showMenuAfterClick) {
        this._temporaryMenuOpened = true;
        this.menuOpened = true;
      }
      const path = event.itemData.path;
      const pointerEvent = event.event;
      if (path && this.menuOpened) {
        this.onNavigationItemClick.emit(event);
        if (this.hideMenuAfterNavigation) {
          this._temporaryMenuOpened = false;
          this.menuOpened = false;
          pointerEvent.stopPropagation();
        }
      } else {
        pointerEvent.preventDefault();
      }
      this.menu.instance.selectItem(event.itemData.path);
    }
  }

  get showMenuAfterClick(): boolean {
    return !this.menuOpened;
  }

  get hideMenuAfterNavigation(): boolean {
    return this.menuMode === 'overlap' || this._temporaryMenuOpened;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public goBack(): void {
    this.location.back();
  }
  onAvatarClick() {
    this.avatarClick.emit();
  }

  private updateDrawer(): void {
    const isSmall = this.screen.sizes['screen-x-small'];
    const isLarge = this.screen.sizes['screen-large'] || this.screen.sizes['screen-x-large'];
    this.menuMode = isLarge ? 'shrink' : 'overlap';
    this.menuRevealMode = isSmall ? 'slide' : 'expand';
    this.minMenuSize = isSmall ? 0 : 60;
    this.shaderEnabled = !isLarge;
  }

  public onToolbarItemChanged(title: string) {
    this.toolBarSecondTitle = title;
    this.cdr.detectChanges();
  }
}
